function setCookie(cname, cvalue, exdays)
{
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

$(function() {
    if ($(".floating-bar").length > 0) {
        $(".floating-bar").each(function() {
            var floatingBar = this;
            var cookieName = $(floatingBar).attr("data-cookie-name");
            $(floatingBar).find(".set-close").click(function() {
                setCookie(cookieName, 1, 1825); // 5 years expiry
                $(floatingBar).fadeOut("slow");
            });
        });
    }
});
